import { render, staticRenderFns } from "./notifications.pug?vue&type=template&id=a170e526&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./notifications.scss?vue&type=style&index=0&id=a170e526&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a170e526",
  null
  
)

export default component.exports